// services/purchasePeriod.js — работният месец (ДДС периодът) на доставките
// (Макс, 27.10.2026).
//
// Защо: „от дата до дата" не върши работа — кантората работи по месеци.
// Фактура от 09 влиза в 09, докато 09 е отворен; качена след приключването му
// (закъсняла от клиента или агента) — в първия отворен месец. Месецът се
// приключва С БУТОН (решение на Макс), когато е подаден ДДС-ът:
// company.purchases_closed_through = 'ГГГГ-ММ' — той и всички преди него са
// приключени. Отваря го наново само администраторът.
//
// Периодът на доставката:
//  - избран от човек (doc.period + period_manual) — важи, каквото и да стане;
//  - потвърдена — записаният при потвърждаването (замразен: по-късно
//    приключване на месеца не я мести);
//  - чернова — изчислява се всеки път от датата: така черновата от 09,
//    непотвърдена до приключването на 09, сама минава в 10.
// Потвърдена отпреди периодите (без doc.period) — месецът на датата.
//
// Чисти функции — ползват ги сървърът, екранът и тестовете.

const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

const isMonth = (m) => MONTH_RE.test(String(m || ''));
const monthOf = (iso) => { const m = String(iso || '').slice(0, 7); return isMonth(m) ? m : ''; };

function addMonths(m, n) {
  const y = Number(m.slice(0, 4)), mo = Number(m.slice(5, 7)) - 1 + n;
  const yy = y + Math.floor(mo / 12), mm = ((mo % 12) + 12) % 12;
  return yy + '-' + String(mm + 1).padStart(2, '0');
}
const nextMonth = (m) => addMonths(m, 1);
const prevMonth = (m) => addMonths(m, -1);

const closedThrough = (company) => (company && isMonth(company.purchases_closed_through) ? company.purchases_closed_through : '');
const isClosed = (company, m) => { const c = closedThrough(company); return !!(c && isMonth(m) && m <= c); };

// Първият отворен месец: след приключения, иначе текущият.
function firstOpen(company, today) {
  const c = closedThrough(company);
  const now = monthOf(today);
  return c ? nextMonth(c) : now;
}

// Месецът, в който влиза документ с тази дата: своят, ако е отворен;
// иначе първият отворен.
function openPeriodFor(company, date, today) {
  const m = monthOf(date) || monthOf(today);
  const c = closedThrough(company);
  return c && m <= c ? nextMonth(c) : m;
}

function periodOf(doc, company, today) {
  const d = doc || {};
  if (isMonth(d.period) && (d.period_manual || d.status === 'confirmed')) return d.period;
  if (d.status === 'confirmed') return monthOf(d.date) || monthOf(d.confirmed_at) || monthOf(today);
  return openPeriodFor(company, d.date || d.created_at, today);
}

// Ръчно избран период: не в приключен месец (освен ако документът вече е
// там) и не преди месеца на документа — фактура не се ползва за ДДС преди
// да е издадена.
function periodError(company, period, doc, date) {
  if (!isMonth(period)) return 'Изберете период (месец).';
  const docMonth = monthOf(date);
  if (docMonth && period < docMonth) return 'Периодът ' + bg(period) + ' е преди датата на документа.';
  if (isClosed(company, period) && !(doc && doc.period === period)) return 'Месец ' + bg(period) + ' е приключен — изберете отворен месец.';
  return null;
}

const bg = (m) => (isMonth(m) ? m.slice(5, 7) + '.' + m.slice(0, 4) : String(m || ''));

// Месеците за избор в документа: от месеца на документа (или първия
// отворен) до два месеца напред от днес.
function choices(company, date, today) {
  const start = openPeriodFor(company, date, today);
  const end = addMonths(monthOf(today), 2);
  const out = [];
  for (let m = start; m <= end && out.length < 24; m = nextMonth(m)) out.push(m);
  return out;
}

module.exports = { isMonth, monthOf, nextMonth, prevMonth, addMonths, closedThrough, isClosed, firstOpen, openPeriodFor, periodOf, periodError, choices, bg };
